import { clampNumber, defineCustomElement, getAttribute, getIntegerAttribute, NectaryElement, updateAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0;--sinch-comp-horizontal-stepper-color-background-default:var(--sinch-sys-color-container-contrast-primary-default);--sinch-comp-horizontal-stepper-color-background-visited-skip:var(--sinch-sys-color-container-contrast-primary-default);--sinch-comp-horizontal-stepper-color-background-active:var(--sinch-ref-color-main-stormy-400);--sinch-comp-horizontal-stepper-color-background-visited:var(--sinch-ref-color-main-snow-700);--sinch-comp-horizontal-stepper-color-background-visited-error:var(--sinch-sys-color-feedback-invalid-background);--sinch-comp-horizontal-stepper-color-border-default:transparent;--sinch-comp-horizontal-stepper-color-border-visited-skip:var(--sinch-ref-color-main-stormy-400);--sinch-comp-horizontal-stepper-color-border-active:transparent;--sinch-comp-horizontal-stepper-color-border-visited:var(--sinch-ref-color-main-stormy-400);--sinch-comp-horizontal-stepper-color-border-visited-error:var(--sinch-ref-color-main-stormy-400);--sinch-comp-horizontal-stepper-color-icon-default:var(--sinch-ref-color-main-stormy-700);--sinch-comp-horizontal-stepper-color-icon-visited-skip:var(--sinch-ref-color-main-stormy-700);--sinch-comp-horizontal-stepper-color-icon-active:var(--sinch-ref-color-main-snow-100);--sinch-comp-horizontal-stepper-color-icon-visited:var(--sinch-ref-color-main-stormy-700);--sinch-comp-horizontal-stepper-color-icon-visited-error:var(--sinch-ref-color-main-stormy-700);--sinch-comp-horizontal-stepper-color-label:var(--sinch-sys-color-text-default);--sinch-comp-horizontal-stepper-color-description:var(--sinch-sys-color-text-muted);--sinch-comp-horizontal-stepper-color-progress:var(--sinch-ref-color-main-snow-700);--sinch-comp-horizontal-stepper-color-progress-visited:var(--sinch-ref-color-main-stormy-400)}#wrapper{position:relative;display:flex;flex-direction:row;gap:28px;width:fit-content}#progress{position:absolute;height:1px;background-color:var(--sinch-comp-horizontal-stepper-color-progress);left:72px;right:72px;top:16px;transform:translateY(-50%)}#bar{position:absolute;height:1px;background-color:var(--sinch-comp-horizontal-stepper-color-progress-visited);left:0;top:0}</style><div id="wrapper"><div id="progress"><div id="bar"></div></div><slot></slot></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-horizontal-stepper', class extends NectaryElement {
  #$itemsSlot;
  #$progressBar;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$itemsSlot = shadowRoot.querySelector('slot');
    this.#$progressBar = shadowRoot.querySelector('#bar');
  }
  connectedCallback() {
    this.setAttribute('role', 'progressbar');
    this.setAttribute('aria-valuemin', '0');
    this.#$itemsSlot.addEventListener('slotchange', this.#updateItems);
  }
  disconnectedCallback() {
    this.#$itemsSlot.removeEventListener('slotchange', this.#updateItems);
  }
  static get observedAttributes() {
    return ['index'];
  }
  attributeChangedCallback(name) {
    switch (name) {
      case 'index':
        {
          this.#updateItems();
          break;
        }
    }
  }
  set index(value) {
    updateAttribute(this, 'index', value);
  }
  get index() {
    return getAttribute(this, 'index', '1');
  }
  #updateItems = () => {
    const $items = this.#$itemsSlot.assignedElements();
    const activeIndex = clampNumber(getIntegerAttribute(this, 'index', 0), 0, $items.length + 1);
    for (let i = 0; i < $items.length; i++) {
      const $el = $items[i];
      const itemIndex = i + 1;
      $el.setAttribute('data-index', String(itemIndex));
      if (itemIndex === activeIndex) {
        $el.setAttribute('data-progress', 'active');
      } else if (itemIndex < activeIndex) {
        $el.setAttribute('data-progress', 'done');
      } else {
        $el.removeAttribute('data-progress');
      }
    }
    const valueIndex = clampNumber(activeIndex - 1, 0, $items.length - 1);
    this.#$progressBar.style.width = `${Math.floor(valueIndex / Math.max(1, $items.length - 1) * 100)}%`;
    this.setAttribute('aria-valuemax', String($items.length));
    this.setAttribute('aria-valuenow', String(valueIndex + 1));
  };
});